import { render, staticRenderFns } from "./CorrectOrder.vue?vue&type=template&id=61b6ed64&scoped=true"
import script from "./CorrectOrder.vue?vue&type=script&lang=ts"
export * from "./CorrectOrder.vue?vue&type=script&lang=ts"
import style0 from "./CorrectOrder.vue?vue&type=style&index=0&id=61b6ed64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6ed64",
  null
  
)

export default component.exports